import { render, staticRenderFns } from "./consultingService.vue?vue&type=template&id=9646143a&scoped=true&"
import script from "./consultingService.vue?vue&type=script&lang=js&"
export * from "./consultingService.vue?vue&type=script&lang=js&"
import style0 from "./consultingService.vue?vue&type=style&index=0&id=9646143a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9646143a",
  null
  
)

export default component.exports